import React, { useState } from 'react';
import { useSpring, animated } from 'react-spring';

function RandomText() {
  const [text, setText] = useState("Hello World");

  const springProps = useSpring({
    to: async (next) => {
      while (true) {
        await next({ 
          transform: `translate(${Math.random() * 200 - 100}px, ${Math.random() * 200 - 100}px)` 
        });
      }
    },
    config: {
      tension: 20,
      friction: 10,
    },
  });

  return (
    <animated.div style={springProps}>
      <h1>{text}</h1>
    </animated.div>
  );
}

export default RandomText;